import { AddressData } from './getAddresses'
import StackAPI from '../../../lib/StackAPI'
import Storage from '../../../lib/Storage'
import { isEmpty } from '../../../utils/isEmpty'

const PARTNER_ENDPOINTS: { [key: string]: string } = {
  PUBLISHER: '/partners/publishers',
  VENDOR: '/partners/vendors',
  AFFILIATE: '/partners/affiliates'
}

export const updatePartnerAddressInfo = async (
  data: AddressData,
  verificationState: string
) => {
  const role = Storage().getActiveRole()

  if (isEmpty(role)) return { error: 'no active role' }

  const { patch } = StackAPI()
  const { id, type } = role

  const params = {
    contact_info_attributes: {
      ...data,
      address_verification_state: verificationState
    }
  }

  const request = {
    path: `${PARTNER_ENDPOINTS[type]}/${id}`,
    params
  }

  try {
    const response = await patch(request)
    if (response.status !== 200) {
      return { error: 'bad response' }
    }

    return response.data
  } catch (_error) {
    return { error: 'unknown error' }
  }
}
